import naja from "naja";
import { Modal } from 'bootstrap';

class FormsExtension {
    initialize(naja)
    {
        window.addEventListener('DOMContentLoaded', this.reloadForm.bind(this));
        naja.snippetHandler.addEventListener('afterUpdate', this.reloadForm.bind(this));
             /*
                 initialize(naja)
    {
        naja.uiHandler.addEventListener('interaction', this.handleInteraction.bind(this));
        naja.addEventListener('complete', this.openModal.bind(this));
    }

              */
    }

    submitForm(input)
    {
        const form = $(input).closest('form');
        if ($(form).hasClass('ajax'))
        {
            if ($(input).hasClass('on-change-skip-validation'))
            {
                let values = new FormData(form[0]);
                values.append('onChangeSkipValidation', 'onChangeSkipValidation');

                // Přidáme ID formuláře, aby bylo snadno dostupné pro Naja eventy
                if (form.attr('id')) {
                    values.append('_form_id', form.attr('id'));
                }

                naja.makeRequest('POST', form[0].action, values, {
                    form: form[0],
                    onChangeSkipValidation: true
                }).then((data) => {
                    window.Nette.init();
                });
            } else {
                naja.uiHandler.submitForm(form[0]);
            }
        } else {
            $(form).submit();
        }
    }

    reloadForm()
    {
        const self = this;

        $(document)
            .off('change', '.on-change-reload-form')
            .off('keyup', 'input[data-autocomplete-provide]')
            .off('keyup', 'input[data-fullsearch-submit]')
            .off('blur', 'input[data-autocomplete-provide]')
            .off('click', '.input-wrapper')
            .off('click', function (event) {})
            .off('keydown', '.enter-with-confirm');

        $(document).on('keydown', '.enter-with-confirm', function (event) {
            if (event.key !== 'Enter') return;
            event.preventDefault();

            const input = this;
            const modal = document.createElement('div');
            modal.classList.add('modal', 'fade');
            modal.tabIndex = -1;
            modal.innerHTML = `
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Chcete uložit a zavřít doklad?</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <button type="button" class="btn btn-primary">Ano</button>
                        <button type="button" class="btn btn-secondary">Ne</button>
                    </div>
                </div>
            </div>
            `;
            document.body.appendChild(modal);

            const bootstrapModal = new Modal(modal);
            let confirmed = false;

            modal.querySelector('.btn-primary').addEventListener('click', () => {
                confirmed = true;
                bootstrapModal.hide();
            });

            modal.querySelector('.btn-secondary').addEventListener('click', () => {
                bootstrapModal.hide();
            });

            modal.addEventListener('hidden.bs.modal', () => {
                modal.remove();
                if (confirmed) {
                    self.submitForm(input);
                }
            }, { once: true });

            modal.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    modal.querySelector('.btn-primary').click();
                }
            });

            bootstrapModal.show();
        });

        $(document).on('change', '.on-change-reload-form', function(event) {
            if ($(this).attr('data-autocomplete-provide')) {
                return;
            }
            self.submitForm(this);
        });

        $(document).on('keyup', 'input[data-fullsearch-submit]', function (event) {
            const $input = $(this);
            const query = ($input.val() || '').trim();

            // if (!query.length || query.length >= 3) {
                self.submitForm($input);
            // }
        });

        $(document).on('blur', 'input[data-autocomplete-provide]', function () {
            setTimeout(() => {
                $('.autocomplete-box').remove();
            }, 100);
        });

        $(document).on('click', function (event) {
            if (!$(event.target).closest('input[data-autocomplete-provide], .autocomplete-box').length) {
                $('.autocomplete-box').remove();
            }
        });

        $('.items-checkbox-all').on('change', function() {
            const isChecked = $(this).is(':checked');
            if(isChecked){
                $('.items-checkbox').prop('checked', true);
            }
            $('.items-checkbox').prop('disabled', isChecked);
        });
    }
}

export default FormsExtension;
